import axios from 'axios';
import { config } from '../config/config';
import { User, Guard } from './';
import dayjs from '../config/dayjs';

export default class Admin {
  private url: string = config.armcareServerUrl;
  private urlNew: string = config.armcareNewServerUrl;
  private user = new User();
  private GUARD = new Guard();
  private stripePK: string = config.armcareStripePK;
  public getStripePK() {
    return this.stripePK;
  }

  public async GetDailyLog(player_id: string) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      const body = {
        data: {
          reportType: 'Daily Log',
          player: player_id,
          createdBy: null,
          updatedBy: null,
        },
      };
      try {
        const response = await fetch(`${this.url}/api/v2/report`, {
          method: 'POST',
          headers,
          body: JSON.stringify(body),
        });
        this.GUARD.verifyError(response);

        const data = await response.json();
        if (data) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetPlayerCSV(player_id: string, onlyAllData?: boolean) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      try {
        const response = await axios.get(`${this.url}/api/v2/player/csv?playerId=${player_id}${onlyAllData ? '&onlyAllData=true' : ''}`, {
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob', // important
        });
        const now = dayjs();
        const urlDownload = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = urlDownload;
        const fileExtension = onlyAllData ? 'csv' : 'xlsx'
        link.setAttribute('download', `Daily Log ${now.format('MM-DD-YYYY h-m-s')}.${fileExtension}`);
        document.body.appendChild(link);
        link.click();
        return { status: true };

      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetAdminPlayersInvitation(
    team: string = '',
    playersGroup: string = '',
    playerName: string = '',
    page: number = 1,
    limit: number = 20,
    sortBy: string = '',
    sortOrder: string = 'desc',
    search: string = ''
  ) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const queryParams = new URLSearchParams({
          ...(team && { team }),
          ...(playerName && { search: playerName }),
          ...(sortBy && { sortBy }),
          ...(playersGroup && { playerGroup: playersGroup }),
          page: page.toString(),
          limit: limit.toString(),
          sortOrder
        });
        const response = await fetch(`${this.url}/api/v2/invitation?${queryParams.toString()}`, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetAdminPlayersInfo() {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.urlNew}/v1/organizations/player-stats`, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if(data) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetMembershipBlocks() {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.url}/api/v2/membership-blocks`, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetSponsorshipAvailable() {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.url}/api/v2/sponsorship-availability`, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetSponsorshipsLevels(type) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.url}/api/v2/sponsorship-levels?type=${type}`, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async BuyMembership(orderData: any) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });

      try {
        const response = await fetch(`${this.url}/api/v2/membership-blocks`, {
          method: 'POST',
          headers,
          body: JSON.stringify(orderData),
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.success) {
          return { ...data, success: true };
        } else {
          return { ...data, success: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetMembershipsAvailable(type: string) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.url}/api/v2/available-membership-blocks?type=` + type, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetAdminPlayersReport(examId: string, firstname: string, lastname: string, date: string) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      let pdfResponse = await axios.get(`${this.url}/api/v2/report-player/${examId}`, {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const formatDate = dayjs(date).format('MDYYYY');
      const fileNameAttr = `${lastname}${firstname}_${formatDate}`;
      const fileName = fileNameAttr.split(' ').join('');

      const url = window.URL.createObjectURL(new Blob([pdfResponse.data]));
      const downloadLink = document.createElement('a');
      downloadLink.href = url;
      downloadLink.setAttribute('download', `${fileName}.pdf`); //or any other extension
      document.body.appendChild(downloadLink);
      downloadLink.click();
    } else {
      return { status: false };
    }
  }

  public async GetPlayerExamById(examId: string, firstname: string, lastname: string, date: string) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      let pdfResponse = await axios.get(`${this.url}/api/v2/report-player/${examId}`, {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const formatDate = dayjs(date).format('MDYYYY');
      const fileNameAttr = `${lastname}${firstname}_${formatDate}`;
      const fileName = fileNameAttr.split(' ').join('');

      const url = window.URL.createObjectURL(new Blob([pdfResponse.data]));
      const downloadLink = document.createElement('a');
      downloadLink.href = url;
      downloadLink.setAttribute('download', `${fileName}.pdf`); //or any other extension
      document.body.appendChild(downloadLink);
      downloadLink.click();
    } else {
      return { status: false };
    }
  }

  public async GetAdminCoachInvitation() {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.url}/api/v2/coach-invitation`, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetBillingHistory() {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.url}/api/v2/billing/logs`, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data) {
          return { status: true, data: data.data };
        } else {
          return { status: false, data };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async sendResponseStatus(id, status) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      const body = {
        data: {
          id: id,
          response: status,
        },
      };
      try {
        const response = await fetch(`${this.url}/api/v2/mobile-team/response`, {
          method: 'POST',
          headers,
          body: JSON.stringify(body),
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.process) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }
  public async AddCard(cardData) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });

      try {
        const response = await fetch(`${this.url}/api/v2/register-payment-method`, {
          method: 'POST',
          headers,
          body: JSON.stringify(cardData),
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.status) {
          return { status: true };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }
  public async DeleteCard(cardData) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });

      try {
        const response = await fetch(`${this.url}/api/v2/detach-payment-method`, {
          method: 'POST',
          headers,
          body: JSON.stringify(cardData),
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.status) {
          return { status: true };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }
  public async EditCard(cardData) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      const updatedCardInfo: any = { default: cardData.default };
      if (cardData.name) {
        updatedCardInfo.name = cardData.name;
      }
      if (cardData.card?.year || cardData.card?.month) {
        updatedCardInfo.card = {};
      }
      if (cardData.card?.year) {
        updatedCardInfo.card.year = cardData.card.year.toString();
      }
      if (cardData.card?.month) {
        updatedCardInfo.card.month = cardData.card.month.toString();
      }

      try {
        const response = await fetch(`${this.url}/api/v2/payment-methods/${cardData.id}`, {
          method: 'PUT',
          headers,
          body: JSON.stringify(updatedCardInfo),
        });
        this.GUARD.verifyError(response);
        const data = await response.json();

        if (data.success) {
          return { status: true };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }
  public async GetPaymentMethods() {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });

      try {
        const response = await fetch(`${this.url}/api/v2/payment-methods`, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.state) {
          return { status: true, data: data.data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetMembershipAvailability() {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });

      try {
        const response = await fetch(`${this.url}/api/v2/sponsorship-availability`, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.success) {
          return { status: true, data: data.data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetBulkProcessing() {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.urlNew}/v1/coach/bulk-processing`, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if(data) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }



  public async HideExam(playerId) {
    // const credentials = this.user.GetUserCredentials() as any;
    // if (credentials.status) {
    //   const token = credentials.data.access_token;
    //   const headers = new Headers({
    //     'Content-Type': 'application/json',
    //     Authorization: `Bearer ${token}`,
    //   });

    //   try {
    //     const response = await fetch(`${this.url}/api/v2/update-visibility-for-teams-exams-reports`, {
    //       method: 'PUT',
    //       headers,
    //       body: JSON.stringify({
    //         playerId: playerId,
    //         action: action,
    //         criteria: criteria
    //       }),
    //     });
    //     this.GUARD.verifyError(response);
    //     const data = await response.json();

    //     if (data.success) {
    //       return {status: true};
    //     } else {
    //       return {status: false};
    //     }
    //   } catch (e) {
    //     console.log(e);
    //     return {status: false};
    //   }
    // } else {
    //   return {status: false};
    // }
    // const p1 = await new Promise(res => setTimeout(() => res('p1'), 3000));
    return { status: true };
  }
}
